import React from 'react'
import { notificationImageContainer, notificationImagePrimary, notificationImageSecondary } from './index.css'
import { Avatar, AvatarProps } from '../images/Avatar.component'
import { cssClass } from '@/shared/utils'

export interface NotificationBaseProps {
  images?: AvatarProps[]
  children?: React.ReactNode
  icon?: React.ReactNode
  alignItems?: string
}

export const NotificationBase: React.FC<NotificationBaseProps> = (
  {
    images,
    children,
    icon,
    alignItems = 'items-center'
  }
) => {

  const showImages = images?.length

  const filterImages = images?.slice(0, 2)
  const mainImageVariation = filterImages?.length === 1 ? 'alone' : 'with-image'
  const getImageClassByIndex = (index: number) => index === 0 ? notificationImagePrimary[mainImageVariation] : notificationImageSecondary

  return (
    <div className={
      cssClass([
        'bg-white-primary p-16 p-24--tablet rounded-20 rounded-16--tablet flex gap-12 gap-20--tablet',
        alignItems,
      ])
    }>
      {showImages && (
        <div className={notificationImageContainer}>
          {filterImages?.map((image, index) => (
            <div key={index + image.alt} className={getImageClassByIndex(index)}>
              <Avatar
                size="100%"
                customBorderRadius={0}
                image={image.image}
                alt={image.alt} />
            </div>
          ))}
        </div>
      )}
      <div className="flex-1">
        {children}
      </div>
      {icon && (
        <div>
          {icon}
        </div>
      )}
    </div>
  )
}